module.exports = __webpack_public_path__ + "static/media/StatViewsCircle.046e7f3d.svg";